import React from "react";
import PropTypes from "prop-types";

import { formatKoreanDate } from "../../../util/date";

import "./CollectionHero.css";

/**
 * 컬렉션 상단 헤더 Hero 영역
 * @param collection
 * @returns {JSX.Element}
 * @constructor
 */
export default function CollectionHero({ collection }) {
  return (
    <section className="CollectionHero">
      <div className="CollectionHero-bg">
        <picture>
          <source
            media="(min-width: 768px)"
            srcSet={collection.resizedBigImage}
          />
          <img
            src={collection.resizedSmallImage}
            alt={collection.title}
            loading="eager"
            fetchPriority="high"
          />
        </picture>
      </div>
      <div className="CollectionHero-overlay" />
      <div className="CollectionHero-content-wrapper">
        <div className="CollectionHero-content">
          <div className="CollectionHero-type">{collection.subtitle}</div>
          <h1 className="CollectionHero-title">{collection.title}</h1>
          {collection.sub_header && (
            <p className="CollectionHero-subtitle">{collection.sub_header}</p>
          )}
          <div className="CollectionHero-date">
            {formatKoreanDate(collection.featured_from)}
          </div>
        </div>
      </div>
    </section>
  );
}

CollectionHero.propTypes = {
  collection: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    sub_header: PropTypes.string,
    resizedBigImage: PropTypes.string,
    resizedSmallImage: PropTypes.string,
    featured_from: PropTypes.string,
  }).isRequired,
};
